import AddressTypeaheadField from "./AddressTypeaheadField";
import {React, useState} from "react";
import API from '../../../config/API';
import i18n from "../../../main/i18n";
import {injectIntl} from 'react-intl';

export default injectIntl(props => {
  const msg = i18n.getMsg(props.intl);
  const [allowNoAddress, setAllowNoAddress] = useState(false);
  const customerNoAddress = props.intl.noAddressValue || null;
  
  props.uiSchema.asyncTypeahead = {

    // Identifies the property of the object returned that will be shown as a suggestion, and stored in the model
    labelKey: 'fullAddress',
    mapping: ({propertyReference, fullAddress}) => {
      return {
        uprn: propertyReference,
        address: fullAddress
      };
    },
    placeholder: msg('searchPlaceholder'),

    /**
     * If the value entered by the user is different from the last value they selected from the list, save the
     * former in the model
     * @param userInput
     * @param lastSelection
     * @return {{address: *}}
     */
    overrideOptions: (userInput, lastSelection) => {
      if (!lastSelection || userInput.trim() !== lastSelection.address) {
        return {address: userInput};
      }
    },

    // https://github.com/ericgio/react-bootstrap-typeahead/blob/master/docs/Filtering.md
    //
    // The filterBy function ensures that all results returned by the API calls are shown as possible selections.
    // If this function is omitted, only results that match (case-insensitively) the query in the input field
    // would be shown. A consequence of this is that (for example) if the user enters "Foo Road" in the input
    // field and the API returns a matching result "Something, Foo Rd, Somewhere", this result would not be shown.
    filterBy: () => true,

    search: (url, query) => {
      return API.scanStation.get(`/address/${query}`).then(response => response.data);
    }
  };

  const handleAllowNoAddressChange = (e) => {
    const checked = e.target.checked || false;
    const addressContainer = document.getElementById('noAddressContainer');
    const addressHelpText = addressContainer ? addressContainer.closest('.field-object').querySelector('.help-block') : null;
    
    if (checked) {
      setAllowNoAddress(true);
      addressHelpText && addressHelpText.classList.add("hidden");  
      const address = {
        "uprn": customerNoAddress.uprn,
        "address": customerNoAddress.address
      }
      props.onChange(address);         
    }      
    else {
      setAllowNoAddress(false);
      addressHelpText && addressHelpText.classList.remove("hidden"); 
      const address = {
        "uprn": "",
        "address": ""
      }
      props.onChange(address);
    }
  };

  return (<>
    {customerNoAddress && <div id="noAddressContainer">
      <label htmlFor="noAddress">
        <input type="checkbox" id="noAddress" onChange={(e) => handleAllowNoAddressChange(e)} /> {msg('noAddress')}
      </label>
      <br/><br/>
    </div>}
    <div className={allowNoAddress ? "hidden" : ""}>
      <AddressTypeaheadField allowNoAddress={allowNoAddress} {...props } />
    </div>
  </>);
})
